[
  {
    "name": "Lab Notes",
    "icon": "img/icon/notepad.png",
    "type": "app",
    "data": {
      "type": "IFrame",
      "url": "fd-lab://notes",
      "gallery": ["img/asset/community.jpg"],
      "desc": "A local note-taking utility for helpdesk evidence and short troubleshooting notes.",
      "feat": "Create notes\nRecord evidence\nKeep simulator work local"
    }
  },
  {
    "name": "Network Toolkit",
    "icon": "img/icon/fd-ncpa.png",
    "type": "app",
    "data": {
      "type": "IFrame",
      "url": "fd-lab://network-toolkit",
      "gallery": ["img/asset/mix.jpg"],
      "desc": "A local toolkit entry for IP, DNS and adapter troubleshooting scenarios.",
      "feat": "Adapter checks\nDNS notes\nTicket-friendly actions"
    }
  },
  {
    "name": "Admin Console Pack",
    "icon": "img/icon/fd-servermanager.png",
    "type": "app",
    "data": {
      "type": "IFrame",
      "url": "fd-lab://admin-console-pack",
      "gallery": ["img/asset/server.jpg"],
      "desc": "A local catalog entry for server and directory administration training tools.",
      "feat": "Server tools\nDirectory workflows\nPolicy and service practice"
    }
  },
  {
    "name": "Paint Board",
    "icon": "img/icon/board.png",
    "type": "app",
    "data": {
      "type": "IFrame",
      "url": "fd-lab://paint-board",
      "gallery": ["img/asset/mixdef.jpg"],
      "desc": "A simple sketching surface for visual notes and screen annotation practice.",
      "feat": "Draw\nAnnotate\nSave evidence"
    }
  }
]
